import React, {Component} from "react";
import TopNavigationComponent from "./component";
import {fetchGraphql, getEnvironment} from "../../utils";

export default class TopNavigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            query: "",
            response: "",
            // Set null so introspection query executed on mount
            schema: null,
            operationName: null,

            avatarURL: "",
            accountName: "",
            loggedIn: false,
        };
        this.graphiql = React.createRef();
    }

    handleLoginAuth = () => {
        if (
            window.location.hostname.includes("dev") ||
            window.location.hostname.includes("stg") ||
            window.location.hostname.includes("trellis")
        ) {
            if(window.location.hostname.includes("fedm")) {
                window.location.replace(
                    `https://id.stg.atlassian-us-gov-mod.com/login?continue=${encodeURIComponent(
                        window.location.href
                    )}`
                );
            } else {
                window.location.replace(
                    `https://id.stg.internal.atlassian.com/login?continue=${encodeURIComponent(
                        window.location.href
                    )}`
                );
            }
        } else {
            if(window.location.hostname.includes("fedm")) {
                window.location.replace(
                    `https://id.atlassian-us-gov-mod.com/login?continue=${encodeURIComponent(
                        window.location.href
                    )}`
                );
            } else {
                window.location.replace(
                    `https://id.atlassian.com/login?continue=${encodeURIComponent(
                        window.location.href
                    )}`
                );
            }
        }
    };

    handleLocalLogin = () => {
        // cause remount
        window.location.reload();
    };

    handleLocalLogout = () => {
        this.setState({
            accountName: "",
            avatarURL: "",
            loggedIn: false,
        });
    };

    handleLogoutAuth = () => {
        if (
            window.location.hostname.includes("dev") ||
            window.location.hostname.includes("stg")
        ) {
            if(window.location.hostname.includes("fedm")) {
                window.location.replace(
                    `https://id.stg.atlassian-us-gov-mod.com/logout?continue=${encodeURIComponent(
                        window.location.href
                    )}`
                );
            } else {
                window.location.replace(
                    `https://id.stg.internal.atlassian.com/logout?continue=${encodeURIComponent(
                        window.location.href
                    )}`
                );
            }
        } else {
            if(window.location.hostname.includes("fedm")) {
                window.location.replace(
                    `https://id.atlassian-us-gov-mod.com/logout?continue=${encodeURIComponent(
                        window.location.href
                    )}`
                );
            } else {
                window.location.replace(
                    `https://id.atlassian.com/logout?continue=${encodeURIComponent(
                        window.location.href
                    )}`
                );
            }
        }
    };

    getFetchUserQuery = () => {
        const {envType} = getEnvironment();

        const centralSchemaQuery =
            '{ "query": ' + JSON.stringify(`query userQuery{ me { user { name picture } } }`) + "}";

        const publicSchemaQuery = "{ \"query\": " + JSON.stringify(`query userQuery{user(accountId: 1234) {name picture}}`) + "}";

        if (envType === "LOCAL") {
            return publicSchemaQuery;
        }

        return centralSchemaQuery;
    }

    getUserData = result => {
        const {envType} = getEnvironment();

        if (envType === "LOCAL") {
            return result.data.user;
        }

        return result.data.me.user;
    }

    fetchUserData = async () => {
        const fetchUserQuery = this.getFetchUserQuery();

        fetchGraphql({query: fetchUserQuery})
            .then((result) => {
                const userData = this.getUserData(result);
                if (userData) {
                    const {name, picture} = userData;
                    this.setState({
                        accountName: name,
                        avatarURL: picture,
                        loggedIn: true,
                    });
                } else {
                    this.setState({
                        accountName: "",
                        avatarURL: "",
                        loggedIn: false,
                    });
                }
            })
    }

    componentDidMount() {
        this.fetchUserData();
    }

    render() {
        const {envType} = getEnvironment()
        const isLocalEnv = envType === "LOCAL";
        return (
            <TopNavigationComponent
                signedIn={this.state.loggedIn}
                avatarURL={this.state.avatarURL}
                accountName={this.state.accountName}
                handleLoginAuth={
                    isLocalEnv ? this.handleLocalLogin : this.handleLoginAuth
                }
                handleLogoutAuth={
                    isLocalEnv ? this.handleLocalLogout : this.handleLogoutAuth
                }
                accountTemplate
            />
        );
    }
}
